export default function LoggedOut() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 16 }}>
      <h2>You've been signed out</h2>
      <a href={`${import.meta.env.VITE_BACKEND_URL}/api/auth/login`}>Sign in again</a>
    </div>
  );
}